import { gql } from '@apollo/client';

const query = gql`
  mutation RemoveReviewAssets($id: String!) {
    removeReviewAsset(id: $id) {
      success
    }
  }
`;

module.exports = query;
